import { PlanShipping } from '@/types/plan';
import { instance } from '..';
import { atomWithQuery } from 'jotai-tanstack-query';
import { AxiosError } from 'axios';
import { targetShippingSeqAtom } from '@/commons/constants';

export const postShipping = async (param: PlanShipping) => {
  return await instance.post('/api_shipping_v2/runShipping', param);
};

export const planShippingListAtom = atomWithQuery<any, AxiosError, any, [string]>(() => ({
  queryKey: ['PLAN_SHIPPING_LIST'],
  queryFn: async ({ queryKey: [] }) => {
    const temp = await getShippingList();
    if (temp && temp.data) {
      return temp.data.data;
    }
  },
}));

const getShippingList = async () => {
  return await instance.get('/api_shipping_v2/shippings', null);
};

export const shippingTargetDetail = atomWithQuery<any, AxiosError, any, [string, number]>((get) => ({
  queryKey: ['TARGET_SHIPPING_DETAIL', get(targetShippingSeqAtom)],
  queryFn: async ({ queryKey: [, targetSeq] }) => {
    if (targetSeq) {
      const temp = await getShippingDetail(targetSeq);
      if (temp && temp.data) {
        return { ...temp.data.data, returnCode: temp.data.returnCode };
      }
    }
  },
}));

const getShippingDetail = async (t_shipping_seq: number) => {
  return await instance.get('/api_shipping_v2/shipping/' + t_shipping_seq);
};

export const postTShipping = async (param: {
  deliverDate: string;
  r_shipping_seq: number;
  t_shipping_seq: number;
  option: { shipping_type: number };
}) => {
  return await instance.post('/api_shipping_v2/changeShippingOption', param);
};

export const postManualShipping = async (param: {
  deliverDate: string;
  r_shipping_seq: number;
  t_shipping_seq: number;
  option: number;
  shippingList: any[];
}) => {
  return await instance.post('/api_shipping_v2/runManualShipping', param);
};

export const deleteShipping = async (t_shipping_seq: number, r_shipping_seq: number) => {
  return await instance.delete(`/api_shipping_v2/shipping/${t_shipping_seq}/${r_shipping_seq}`, null);
};

export const shippingComplete = async (t_shipping_seq: number) => {
  return await instance.put('/api_shipping_v2/shipping/complete', { t_shipping_seq });
};

export const shippingImportExcel = async (t_shipping_seq: number) => {
  return await instance.get('/api_shipping_v2/shipping/import_excel', { params: { t_shipping_seq } });
};
